/** 返回上一页（如果没有上一页则跳转到首页） */
export const useGoBack = () => {
  const router = useRouter()
  if (router.options.history.state.back) {
    router.back()
  } else {
    useLocalePush('/')
  }
}
